import { useEffect, useState } from "react";
import { RootState } from "app/store";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

type TargetPoiName =
  | NonNullable<
      RootState["panorama"]["currentFieldDetails"]
    >["scoutPoints"][number]["name"]
  | null;

type UsePoiRead = () => TargetPoiName;

/**
 * # Open a POI
 *
 * @related `useInitialPoi`
 */
export const usePoiRead: UsePoiRead = () => {
  const [selectedPoi, setSelectedPoi] = useState<TargetPoiName>(null);

  // This listener is for when krpano requests for a POI to be opened
  useEffect(() => {
    const readPoiHandler = (event: WindowEventMap["krpano__poi_read"]) => {
      // NOTE: Only check for `undefined`, we expect `null` when closing the POI
      if (
        notNullNorUndefined(event.detail) &&
        event.detail.poiName !== undefined
      ) {
        setSelectedPoi(event.detail.poiName);
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener("krpano__poi_read", readPoiHandler);
    return () => {
      window.removeEventListener("krpano__poi_read", readPoiHandler);
    };
  }, []);

  return selectedPoi;
};
